//export default class Team {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.team');
//   }
//}
//
//new Team();
import Swiper, { Navigation } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";

document.addEventListener("DOMContentLoaded", () => {
  const mySwiper = new Swiper(".swiper", {
    // Optional parameters
    modules: [Navigation],
    direction: "horizontal",
    loop: true,
    allowTouchMove: true,
    observer: true,
    observeSlideChildren: true,
    observeParents: true,
    updateOnWindowResize: true,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-team-next",
      prevEl: ".swiper-team-prev",
    },
  });

  document.querySelectorAll(".person").forEach((element) => {
    element.addEventListener("click", function () {
      var slide = element.dataset.slide;
      document.querySelector(".popup").style.display = "flex";
      // mySwiper.slideTo(slide, false, false);
      document.querySelector("body").style.overflow = "hidden";
      setTimeout(() => {
        mySwiper.slideTo(slide, 0, false);
        mySwiper.update();
      }, 10);
    });
  });

  document.querySelectorAll(".close-popup").forEach(function (element) {
    element.addEventListener("click", () => {
      popup.style.display = "none";
      document.querySelector("body").style.overflow = "initial";
    });
  });

  const popup = document.querySelector(".popup");
  window.onclick = function (event) {
    if (event.target === popup) {
      popup.style.display = "none";
      document.querySelector("body").style.overflow = "initial";
    }
  };

});



